(function ($) {
  'use strict';

  // Guard against double-binding when multiple instances of the section load this file
  if (window.pageHeroNewsletterInit) return;
  window.pageHeroNewsletterInit = true;

  // Form submit handling lives in newsletter-capture.js (shared with cta-newsletter)

  $(function () {
    // Hero video: the Safari autoplay watchdog is shared, in hero-video.js

    // Scroll cue: nudge the chevron down when the cursor comes near it
    var PROXIMITY_RADIUS = 150;
    var $cues = $('.hero-newsletter-scroll-cue');

    if ($cues.length) {
      var lastEvent = null;
      var frameQueued = false;

      var updateProximity = function () {
        frameQueued = false;
        $cues.each(function () {
          var rect = this.getBoundingClientRect();
          var dx = lastEvent.clientX - (rect.left + rect.width / 2);
          var dy = lastEvent.clientY - (rect.top + rect.height / 2);
          $(this).toggleClass('is-near', Math.hypot(dx, dy) <= PROXIMITY_RADIUS);
        });
      };

      $(document).on('mousemove', function (e) {
        lastEvent = e;
        if (!frameQueued) {
          frameQueued = true;
          window.requestAnimationFrame(updateProximity);
        }
      });
    }

    // Clicking the cue scrolls to the next section on the page
    $(document).on('click', '.hero-newsletter-scroll-cue', function () {
      var $section = $(this).closest('.shopify-section');
      var $next = $section.next();
      var targetTop = $next.length
        ? $next.offset().top
        : $section.offset().top + $section.outerHeight();

      $('html, body').animate({ scrollTop: targetTop }, 600);
    });
  });
})(jQuery);
